import React, { useEffect, useState } from 'react'

import calendar from '../../util/calendar.png'
import Post from '../copmponents/Post'
import SignatureModal from '../copmponents/SignatureModal'
import RegistrationCourse from '../copmponents/RegistrationCourse'
import PaymentModal from '../copmponents/PaymentModal'
import axios from 'axios'
import { useParams, useSearchParams } from 'react-router-dom'
import Package from '../copmponents/Package'
import Select from 'react-select'

const Home = () => {
    const GET_URL = 'dashboard/member/open_qualification_day_register_and_package'
    const [fetchData, setFetchData] = useState([])
    const [selectedArea, setSelectedArea] = useState(null)
    const [selectedMonth, setSelectedMonth] = useState(null)
    const AREA_OPTIONS = [
        { value: null, label: 'כל האזורים' },
        { value: 'צפון', label: 'צפון' },
        { value: 'מרכז', label: 'מרכז' },
        { value: 'דרום', label: 'דרום' },
    ]
    const MONTH_OPTIONS = [
        { value: null, label: 'כל החודשים' },
        { value: 1,  label: 'ינואר' },  { value: 2,  label: 'פברואר' },
        { value: 3,  label: 'מרץ' },    { value: 4,  label: 'אפריל' },
        { value: 5,  label: 'מאי' },    { value: 6,  label: 'יוני' },
        { value: 7,  label: 'יולי' },   { value: 8,  label: 'אוגוסט' },
        { value: 9,  label: 'ספטמבר' }, { value: 10, label: 'אוקטובר' },
        { value: 11, label: 'נובמבר' }, { value: 12, label: 'דצמבר' },
    ]
    const selectStyles = {
        control: (base, state) => ({
            ...base,
            borderRadius: '999px',
            borderColor: state.isFocused ? '#0d406b' : '#d1d5db',
            boxShadow: state.isFocused ? '0 0 0 2px #0d406b44' : base.boxShadow,
            paddingInline: '2px', minWidth: '110px', minHeight: '30px', height: '30px',
            cursor: 'pointer', '&:hover': { borderColor: '#0d406b' },
        }),
        valueContainer: (base) => ({ ...base, padding: '0 6px' }),
        indicatorsContainer: (base) => ({ ...base, height: '30px' }),
        dropdownIndicator: (base) => ({ ...base, padding: '0 4px' }),
        option: (base, state) => ({
            ...base,
            backgroundColor: state.isSelected ? '#0d406b' : state.isFocused ? '#e8f0f7' : 'white',
            color: state.isSelected ? 'white' : '#374151',
            textAlign: 'right', fontSize: '13px', padding: '6px 10px', cursor: 'pointer',
        }),
        singleValue: (base) => ({ ...base, color: '#0d406b', fontWeight: 600, fontSize: '13px' }),
        menu: (base) => ({ ...base, borderRadius: '12px', overflow: 'hidden', boxShadow: '0 4px 16px #0002' }),
        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    }
    const filteredData = fetchData
        .filter(course => !selectedArea || course.area === selectedArea)
        .filter(course => {
            if (!selectedMonth) return true
            const dateStr = course.dateStart_pack
            if (!dateStr) return false
            return new Date(dateStr).getMonth() + 1 === selectedMonth
        })
   const [searchParams]= useSearchParams();
   const qid = searchParams.get("qId");     // "credits"
  const pid = searchParams.get("pId");   // "2"
    //  const { corseId } = useParams();
    const getTrainingDays = async () => {

        // if (!corseId)
        //     await axios.get(GET_URL, {
        //         // params: {
        //         //     "page": page
        //         //     , "size": perPage,
        //         // }
        //     })
        //         .then(response => {
        //             if (response.status == 200) {
        //                 setFetchData(response?.data)
        //             }
        //         })
        // else
        // {
        await axios.get(GET_URL, {
            params: {
                "qId": qid,
                "pId": pid  
                //     , "size": perPage,
            }
        }).then(response => {
                if (response.status == 200) {
                    setFetchData(response?.data)
                    // setShow(true)
                }
            })
    }
        useEffect(() => {
            getTrainingDays()
        }, [])
        //   const [modalIsOpen,setModalIsOpen] = useState(-1);  
        //   const handleColse = () => {
        //     console.log("first")
        //     setModalIsOpen(-1)
        // }
  return (
    <div className='w-full h-full flex flex-col  gap-1'>
      
            
            {/* <h1 className='text-right mr-3 font-semibold text-[#0042F5] text-lg'>לשבוע הקרוב</h1>
            <div className='w-full flex items-center justify-center border border-[#A7A7A7] rounded-lg my-1 p-2 '> */}
            {/* <div className="flex-grow overflow-auto bg-white p-2 rounded-lg shadow"> */}
                {/* <img src={calendar} alt="" />
                <span className='ml-4'>השבוע  אין קורסים שנרשמת</span>
            </div> */}
            {/* <h1 className='text-right mr-3 font-semibold text-[#0042F5] text-lg'>ימי עיון לשבוע הקרוב</h1> */}
            <h1 className='text-right mr-3 font-semibold text-[#0042F5] text-lg'>ימי עיון </h1>
            <div className='flex justify-end gap-2 px-2'>
                <Select
                    options={MONTH_OPTIONS}
                    value={MONTH_OPTIONS.find(o => o.value === selectedMonth) ?? MONTH_OPTIONS[0]}
                    onChange={(opt) => setSelectedMonth(opt?.value ?? null)}
                    isSearchable={false}
                    menuPlacement="auto"
                    menuPortalTarget={document.body}
                    styles={selectStyles}
                />
                <Select
                    options={AREA_OPTIONS}
                    value={AREA_OPTIONS.find(o => o.value === selectedArea) ?? AREA_OPTIONS[0]}
                    onChange={(opt) => setSelectedArea(opt?.value ?? null)}
                    isSearchable={false}
                    menuPlacement="auto"
                    menuPortalTarget={document.body}
                    styles={selectStyles}
                />
            </div>
            {/* <div className='w-full h-full grid grid-cols-2 my-2 gap-3 overflow-y-auto pb-28'> */}
            {/* <div className='w-full h-[65%] grid grid-cols-2 my-2 gap-3 overflow-y-auto '> */}
            <div className="flex-grow overflow-auto bg-white p-2 rounded-lg shadow">
            <div className='w-full  grid grid-cols-2 my-2 gap-3 overflow-y-auto '>
            {filteredData.map((course,index) => { return course?.type=="qul"?<Post course={course} Fromlink={qid==course?.mySelfQualificationDto?.id?"popup":""} getTrainingDays={getTrainingDays}
            // setModalIsOpen={()=>setModalIsOpen(index)}
            
            key={index}/>:<Package course={course} key={index} Fromlink={pid==course?.id_pack?"popup":""} getTrainingDays={getTrainingDays}></Package>  })}
                {/* <Post></Post>    
                <Post></Post>    
                <Post></Post>    
                <Post></Post>    
                <Post></Post>   
                <RegistrationCourse/> */}
                {/* <PaymentModal/> */}
                {/* <SignatureModal/>  */}
                {/* {modalIsOpen!=-1 &&<RegistrationCourse course={fetchData[modalIsOpen]}onClose={handleColse}/>}  */}
            </div>
            </div>
        {/* <NavBar selected={selected} setSelected={setSelected}></NavBar> */}
       
    </div>
  )
}

export default Home